import React from 'react';
import { useSelector } from 'react-redux';
import { t } from 'i18next';
import { BUSINESS_CATEGORY_FIELD_NAME } from '../constants/common';
import getSiteIdToRecreate from '../modules/sites/selectors/get-site-id-recreate';
import getSiteIdToSwitch from '../modules/sites/selectors/site-id-to-switch-template';
import getLocale from '../modules/i18n/selectors/locale';
import BusinessCategoryField from '../components/business-category-field';

const getCaptions = () => ({
  placeholder: t('Search for your business or website type'),
  noResultsText: t('No result'),
});

const BusinessCategoryFieldContainer = (props) => {
  const locale = useSelector(getLocale);
  const siteIdToRecreate = useSelector(getSiteIdToRecreate);
  const siteIdToSwitch = useSelector(getSiteIdToSwitch);
  const siteId = siteIdToRecreate || siteIdToSwitch || null;
  const captions = getCaptions();

  return (
    <BusinessCategoryField
      {...props}
      name={BUSINESS_CATEGORY_FIELD_NAME}
      captions={captions}
      siteId={siteId}
      locale={locale}
    />
  );
};

export default BusinessCategoryFieldContainer;
